import { DownloadIcon, FileSearchIcon, Loader2Icon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { PPTX_MIME_TYPE } from './document-viewer/document-viewer-registry';

type GeneratedFilePreviewUnavailableProps = {
  filename: string;
  isDownloading: boolean;
  mediaType: string | null | undefined;
  onDownload: () => void;
};

export function GeneratedFilePreviewUnavailable({
  filename,
  isDownloading,
  mediaType,
  onDownload,
}: GeneratedFilePreviewUnavailableProps) {
  const noun = mediaType === PPTX_MIME_TYPE ? 'présentation' : 'classeur';
  return (
    <div className="flex h-full items-center justify-center bg-muted/35 p-8 text-center" data-testid="preview-unavailable">
      <div className="flex max-w-sm flex-col items-center gap-4">
        <div className="flex size-11 items-center justify-center rounded-xl bg-background text-muted-foreground shadow-sm">
          <FileSearchIcon className="size-5" aria-hidden />
        </div>
        <div className="space-y-1.5">
          <h2 className="text-sm font-semibold text-foreground">Aperçu indisponible</h2>
          <p className="text-sm text-muted-foreground">
            Ce {noun} ne peut pas être affiché dans le panneau. Téléchargez {filename} pour l’ouvrir dans
            votre application.
          </p>
        </div>
        <Button disabled={isDownloading} onClick={onDownload} size="sm" type="button">
          {isDownloading
            ? <Loader2Icon className="size-3.5 animate-spin" data-icon="inline-start" aria-hidden />
            : <DownloadIcon className="size-3.5" data-icon="inline-start" aria-hidden />}
          Télécharger
        </Button>
      </div>
    </div>
  );
}
